import React from 'react';

import DateType from './Types/DateType';
import ChoiceType from './Types/ChoiceType';
import DisplayType from './Types/DisplayType';
import LongTextType from './Types/LongTextType';
import OpenChoiceType from './Types/OpenChoiceType';
import AttachmentType from './Types/AttachmentType';
import ShortTextType from './Types/ShortTextType';
import YesNoType from './Types/YesNoType'
import IntegerType from './Types/IntegerType';

export default function TypeFactory(item) {
  switch (item.type) {
    case 'date':
      return <DateType question={item} />;
    case 'choice':
      return <ChoiceType question={item} />;
    case 'display':
      return <DisplayType question={item} />;
    case 'text':
      return <LongTextType question={item} />;
    case 'string':
      return <ShortTextType question={item} />;
    case 'integer':
      return <IntegerType question={item} />;
    case 'open-choice':
      return <OpenChoiceType question={item} />;
    case 'boolean':
      return <YesNoType question={item} />;
    case 'attachment':
      return <AttachmentType question={item} />;
    default:
      return false;
  }
};